import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ContactWindow = ({ isContactOpen, setIsContactOpen, zFILO, addToZFILO, removeFromZFILO }) => {
    const zIndex = zFILO.indexOf('contact') !== -1 ? 1000 + zFILO.indexOf('contact') : 1000;

    const [formData, setFormData] = useState({
        to: 'Lovely WAAS Staff',
        from: '',
        phone: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');

    const location = useLocation();
    const navigate = useNavigate();

    const handleClose = () => {
        setIsContactOpen(false);
        removeFromZFILO('contact');
        navigate('/');
    };

    const handleMinimize = () => {
        setIsContactOpen(false);
        removeFromZFILO('contact');
        navigate('/');
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        setLoading(true);
        setStatus('');

        try {
            // Save to DB
            await fetch('https://waas-desktop-server.wl.r.appspot.com/api/contacts', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: formData.from,
                    phone: formData.phone,
                    message: formData.message
                })
            });

            // Send Email
            await fetch('https://waas-desktop-server.wl.r.appspot.com/api/sendEmail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: formData.from,
                    message: formData.message
                })
            });

            setStatus('Message sent successfully!');
            setFormData({ to: 'Lovely WAAS Staff', from: '', phone: '', message: '' });
        } catch (err) {
            setStatus('Failed to send message. Please try again.');
        }

        setLoading(false);
    };

    if (!isContactOpen) return null;

    return (
        <>
            <Helmet>
                <title>Contact Us | We Are A Site</title>
                <meta name="description" content="Get in touch to start your custom website project. We’re friendly, fast, and ready to help your business grow." />
            </Helmet>
            <div className='ContactWindow DesktopWindow' style={{ zIndex }}>
                <div className='ContactWindowTitleBar DesktopWindowTitleBar'>
                    <span className='Title'>Contact Us</span>
                    <div className='ResizeButtons'>
                        <img src='/images/MinimizeIcon.png' alt='Minimize' onClick={handleMinimize} />
                        <img src='/images/MaximizeIcon.png' alt='Maximize' />
                        <img src='/images/SystemMessageCloseButton.png' alt='Close' onClick={handleClose} />
                    </div>
                </div>
                <div className='ContactWindowFunctionBar'>
                    <div className='ContactWindowFunctionBarSocialIcons'>
                        <a href="https://www.linkedin.com/company/weareasite-com" target="_blank" rel="noopener noreferrer">
                            <img src="/images/LinkedInIcon.png" alt="LinkedIn" />
                        </a>
                        <a href="https://www.instagram.com/weareasite" target="_blank" rel="noopener noreferrer">
                            <img src="/images/InstagramIcon.png" alt="Instagram" />
                        </a>
                        <a href="tel:4809399557">
                            <img src="/images/PhoneIcon.png" alt="Phone" />
                        </a>
                    </div>
                    <button
                        className='SendMessageButton'
                        onClick={handleSubmit}
                        disabled={loading || !formData.from.trim() || !formData.message.trim()}
                    >
                        {!status ? `${loading ? 'SENDING...' : 'SEND MESSAGE'}` : 'SENT'}
                        <img src='/images/SendIcon.png' alt='Send Message' />
                    </button>
                </div>
                <div className='DraftEmail'>
                    {!status && <>
                        <div className='EmailInput'>
                            <label>To:</label>
                            <input type='email' value={formData.to} disabled />
                        </div>
                        <div className='EmailInput'>
                            <label>From:</label>
                            <input type='email' name='from' value={formData.from} onChange={handleChange} placeholder='Your email' />
                        </div>
                        <div className='EmailInput'>
                            <input type='text' name='phone' value={formData.phone} onChange={handleChange} placeholder='Your phone (optional)' />
                        </div>
                        <div className='EmailTextArea'>
                            <label>Message:</label>
                            <textarea name='message' value={formData.message} onChange={handleChange} placeholder='Type your message here...'></textarea>
                        </div>
                    </>}
                    {status && <p className='statusMessage'>{status}</p>}
                </div>
            </div>
        </>
    );
};

export default ContactWindow;
